var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20485 5.26122C7.53912 4.83757 6.66797 5.31579 6.66797 6.10488V14.1282C6.66797 14.9173 7.53912 15.3955 8.20484 14.9719L14.5089 10.9602C15.1264 10.5672 15.1264 9.66583 14.5089 9.27288L8.20485 5.26122Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlayIcon);
export default __webpack_public_path__ + "static/media/AudioPlayIcon.08c1b873dad8b54b27de96bbc9f07174.svg";
export { ForwardRef as ReactComponent };